import React from 'react'
import { NavLink } from 'react-router-dom'
import NavLinkBook from './NavLinkBook'

import './menu.css'

const Menu = (props) => (
  <nav className='secondary-nav nav'>
    <div className='container'>
      <div className='nav-left'>
        <NavLink to='/adoption' className='nav-item' activeClassName='is-active'>
          <span>Adoção</span>
        </NavLink>
        <NavLinkBook activeClassName='is-active' />
      </div>
      <div className='nav-right'>
        <p className='nav-item' />
      </div>
    </div>
  </nav>
)

export default Menu



// WEBPACK FOOTER //
// ./src/components/Menu/index.js